import Vue from "vue";

import "@/assets/css/main.pcss";
import i18n from "@/i18n";
import "./font-awesome";
import IndexComponent from "./components";
import MoskitoTooltip from "@/moskito-common/components/MoskitoTooltip";

Vue.component("MoskitoTooltip", MoskitoTooltip);

const VUE_MOUNT_SELECTOR = "#wp-pagespeed-score-edit-page";

Vue.config.productionTip = false;

const vue = new Vue({
  render: (h) => h(IndexComponent),
  i18n,
});

vue.$mount(VUE_MOUNT_SELECTOR);
